import {httpClient_get, httpClient_post} from '../../helpers/api';

function getParticipantsService(trainingSessionId) {
  return httpClient_get(
    `/moderator/getparticipants?training_session_id=${trainingSessionId}`,
  )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
}

function getQuizStatisticsService(trainingSessionId) {
  // return quizStatistics;
  return httpClient_get(
    `/moderator/getquizstatistics?training_session_id=${trainingSessionId}`,
  )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
}

function changeStatusParticipantService({trainingSessionId, userId, status}) {
  return httpClient_post(
    `/moderator/activateparticipant?training_session_id=${trainingSessionId}&user_id=${userId}&status=${status}`,
    null,
  )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
}

function getTeamsService(gameSessionId) {
  return httpClient_get(
    `/moderator/stratedge/getteams?game_session_id=${gameSessionId}`,
  )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
}

function assignmentTeamsService(list) {
  return httpClient_post(`/moderator/stratedge/updateteamaffectations`, list)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
}

export {
  getParticipantsService,
  changeStatusParticipantService,
  getQuizStatisticsService,
  getTeamsService,
  assignmentTeamsService,
};
